import { z } from "zod";
import { telemetryDataProviderSchema } from "../_shared";

export const fetchAndUpdateTripEcoDrivingPayloadSchema = z.object({
  tripUuid: z.uuid(),
  dataProvider: telemetryDataProviderSchema,
  isSendingNotification: z.boolean().optional(),
});

export type FetchAndUpdateTripEcoDrivingPayload = z.infer<
  typeof fetchAndUpdateTripEcoDrivingPayloadSchema
>;
